module.exports = __webpack_public_path__ + "static/media/vnda21.e449e4a3.png";